import * as rootLogger from 'loglevel';
import {default as remoteModule} from 'loglevel-plugin-remote';

export const remote = remoteModule.noConflict();
export const log = remote.apply(rootLogger, {
    format: (message) => {
        message.level = message.level.label;
        return message;
    },
    tokenName: 'Identity',
});
export default log;

rootLogger.noConflict();
rootLogger.enableAll();
remote.setToken(undefined);

/**
 * Turns a Response into a string.
 *
 * @param {Response} response
 * @return {Promise<string>} even if the parameter isn't a string, so we won't lose a log;
 */
export function responseAsJson(response)
{
    if (response instanceof Response) {
        return response.text().then(text => {
            return JSON.stringify({status: response.status, header: response.headers, url: response.url, text});
        });
    } else {
        try {
            log.error(`The response wasn't a Response ${response}`);
        } catch {
            log.error(`The response wasn't a Response, couldn't log the response.`);
        }
        return Promise.reject(JSON.stringify(response));
    }
}
